import { Suspense } from "react";
import { Outlet, ScrollRestoration } from "react-router-dom";

import AuthStepsModal from "@organisms/AuthStepsModal";
import useRootLayout from "./useRootLayout";
import ModalInformativeChangeLocation from "@/components/Molecules/ModalInformartiveChangeLocation";
import ModalAddressForm from "@/components/Organisms/ModalAddressForm";
import ModalGetTokenPlus from "@/components/Molecules/ModalGetTokenPlus";
import ModalHearAboutUs from "@/components/Organisms/ModalHearAboutUs";
import ModalContextProvider from "@/context/ModalContext";
import ModalStoreReview from "@/components/Molecules/ModalStoreReview";
import Toaster from "@/components/Atoms/Toaster";

const RootLayout = () => {
  const {
    isAuthModalOpen,
    handleCloseModalAuth,
    isOpenModalInformativeChangeLocation,
    handleCloseModalInformativeChangeLocation,
    isAddressModalOpen,
    setIsAddressModalOpen,
    openModalHearAboutUs,
    handleCloseModalHearAboutUs,
    typeModalHearAboutUs,
    openModalStoreReview,
    setOpenModalStoreReview,
    storeReview,
  } = useRootLayout();

  return (
    <ModalContextProvider>
      <Suspense fallback="">
        {isAuthModalOpen && (
          <AuthStepsModal isOpen={isAuthModalOpen} dismissable onModalClose={handleCloseModalAuth} />
        )}

        {openModalHearAboutUs && (
          <ModalHearAboutUs
            type={typeModalHearAboutUs}
            isOpen={openModalHearAboutUs}
            handleClose={handleCloseModalHearAboutUs}
          />
        )}

        {isAddressModalOpen && (
          <ModalAddressForm isOpen={isAddressModalOpen} toggleAddressModal={setIsAddressModalOpen} />
        )}

        {openModalStoreReview && (
          <ModalStoreReview isOpen handleClose={() => setOpenModalStoreReview(false)} review={storeReview!} />
        )}
      </Suspense>

      {isOpenModalInformativeChangeLocation && (
        <ModalInformativeChangeLocation
          open={isOpenModalInformativeChangeLocation}
          onClose={handleCloseModalInformativeChangeLocation}
        />
      )}

      <ScrollRestoration />
      <Outlet />
      <ModalGetTokenPlus />
      <Toaster />
    </ModalContextProvider>
  );
};

export default RootLayout;
